// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapersSidebar-cls1_VWj","cls2":"RelatedPapersSidebar-cls2_NeQ RelatedPapersSidebar-cls1_VWj"};